import { render, staticRenderFns } from "./style-card.vue?vue&type=template&id=2e74d787&scoped=true"
import script from "./style-card.vue?vue&type=script&lang=js"
export * from "./style-card.vue?vue&type=script&lang=js"
import style0 from "./style-card.vue?vue&type=style&index=0&id=2e74d787&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74d787",
  null
  
)

export default component.exports